<template>
    <div>
        <el-form :model="form" ref="formTransferencia" label-position="top">
            <el-alert
                :title="'Tem certeza que deseja colocar o aluno(a) ' + alunoNome + ' em transferência?'"
                type="warning"
                :closable="false"
                show-icon
                class="u-mb-20">
            </el-alert>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Destino Provável" prop="tipo_rede_destino" :rules="$requiredChange">
                        <el-select v-model="form.tipo_rede_destino" placeholder="Selecione..." style="width: 100%" @change="onChangeTipoRede">
                            <el-option label="REDE MUNICIPAL" value="municipal"></el-option>
                            <el-option label="OUTRA REDE" value="outra"></el-option>
                            <el-option label="NÃO INFORMADO" value="nao_informado"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="form.tipo_rede_destino === 'municipal'">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição de Destino" prop="instituicao_destino_id" :rules="$requiredChange">
                        <el-select v-model="form.instituicao_destino_id" filterable placeholder="Selecione a instituição..." style="width: 100%">
                            <el-option v-for="inst in instituicoesAtivas" :key="inst.id" :label="inst.nome" :value="inst.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <template v-if="form.tipo_rede_destino === 'outra'">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Local do Destino" prop="local_destino" :rules="$requiredChange">
                            <el-select v-model="form.local_destino" placeholder="Selecione..." style="width: 100%" @change="onChangeLocal">
                                <el-option label="MESMA CIDADE" value="mesma_cidade"></el-option>
                                <el-option label="OUTRA CIDADE" value="outra_cidade"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="form.local_destino === 'outra_cidade'">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Estado de Destino" prop="estado_destino" :rules="$requiredChange">
                            <el-select v-model="form.estado_destino" filterable placeholder="Selecione o estado..." style="width: 100%" @change="onChangeEstado">
                                <el-option v-for="est in estados" :key="est.id" :label="est.nome" :value="est.uf"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Cidade de Destino" prop="cidade_destino" :rules="$requiredChange">
                            <el-select v-model="form.cidade_destino" filterable placeholder="Selecione a cidade..." style="width: 100%" :loading="loadingCidades">
                                <el-option v-for="cid in cidades" :key="cid.id" :label="cid.nome" :value="cid.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="form.local_destino === 'mesma_cidade' || form.local_destino === 'outra_cidade'">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Nome da Instituição de Destino" prop="nome_instituicao_destino" :rules="$requiredBlur">
                            <el-input v-model="form.nome_instituicao_destino" maxlength="191" @input="form.nome_instituicao_destino = $event.toUpperCase()"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <div class="u-text-right u-mt-20">
                <el-button @click="$emit('closeModal')">CANCELAR</el-button>
                <el-button type="primary" @click="confirmarTransferencia" :loading="loading">CONFIRMAR TRANSFERÊNCIA</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['alunoId', 'matriculaId', 'alunoNome'],
    data() {
        return {
            loading: false,
            loadingCidades: false,
            instituicoesAtivas: [],
            estados: [],
            cidades: [],
            form: {
                tipo_rede_destino: null,
                instituicao_destino_id: null,
                local_destino: null,
                nome_instituicao_destino: null,
                cidade_destino: null,
                estado_destino: null
            }
        }
    },
    created() {
        this.fetchInstituicoes();
        this.fetchEstados();
    },
    methods: {
        fetchInstituicoes() {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllInstituicoesAtivas`, this.$store.getters.getHeaderAuth).then(response => {
                this.instituicoesAtivas = response.data;
            });
        },
        fetchEstados() {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/estado/getAll`, this.$store.getters.getHeaderAuth).then(response => {
                this.estados = response.data;
            });
        },
        onChangeEstado(uf) {
            this.form.cidade_destino = null;
            this.cidades = [];
            let estado = this.estados.find(e => e.uf === uf);
            if (estado) {
                this.loadingCidades = true;
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/cidade/getByEstado/${estado.id}`, this.$store.getters.getHeaderAuth).then(response => {
                    this.cidades = response.data;
                    this.loadingCidades = false;
                });
            }
        },
        onChangeTipoRede() {
            this.form.instituicao_destino_id = null;
            this.form.local_destino = null;
            this.form.nome_instituicao_destino = null;
            this.form.cidade_destino = null;
            this.form.estado_destino = null;
        },
        onChangeLocal() {
            this.form.nome_instituicao_destino = null;
            this.form.cidade_destino = null;
            this.form.estado_destino = null;
        },
        confirmarTransferencia() {
            this.$refs.formTransferencia.validate(valid => {
                if (valid) {
                    this.loading = true;
                    window.eventBus.$emit('loading', true);
                    let p = this.$store.state.config.periodo.id;
                    let a_id = this.alunoId ? this.alunoId : '0';
                    let m_id = this.matriculaId ? this.matriculaId : '0';
                    let url = `${this.$store.state.config.baseUrlApi}/api/matricula/storeTransferencia/${p}/${a_id}/${m_id}`;
                    
                    this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth).then(response => {
                        this.loading = false;
                        window.eventBus.$emit('loading', false);
                        
                        if (typeof response.data.throw !== 'undefined') {
                            this.$alert(response.data.throw.msg, 'Atenção', {
                                confirmButtonText: 'OK',
                                type: response.data.throw.type,
                                center: true
                            }).catch(() => {});
                        } else {
                            this.$emit('success', response.data);
                        }
                    }).catch(error => {
                        this.loading = false;
                        window.eventBus.$emit('loading', false);
                        this.$store.commit('throwException', error);
                    });
                }
            });
        }
    }
}
</script>
